import React, {useCallback, useState} from 'react'
import {useNavigate} from 'react-router'
import styled from '@emotion/styled'
import {Button} from '../../../shared/Button'
import Modal from '../../../shared/Modal'
import {ShareLinkInput} from './PaymentDetailsStep.styles'

// Input and Copy button share one forced height so they always line up.
const LinkRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & > input,
  & > button {
    height: 36px !important;
    min-height: 36px !important;
    box-sizing: border-box !important;
    margin: 0 !important;
  }
`

// "Generated Link" copy modal shared by the Keap Partner link flows (1:Many
// and the Account Setup payment-details step): read-only URL, Copy, and a Home
// button in the footer.
export function GeneratedLinkModal({link, onClose}) {
  const navigate = useNavigate()
  const [linkCopied, setLinkCopied] = useState(false)

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(link)
      setLinkCopied(true)
      setTimeout(() => setLinkCopied(false), 5000)
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }, [link])

  return (
    <Modal
      isOpen={Boolean(link)}
      onClose={onClose}
      title="Generated Link"
      size="md"
      closeOnBackdrop={false}
      footer={
        <Button
          variant="solid-gradiant"
          size="sm"
          style={{minWidth: '100px'}}
          onClick={() => navigate('/')}
        >
          Home
        </Button>
      }
    >
      <label
        htmlFor="generated-link-url"
        style={{display: 'block', lineHeight: 1.2, marginBottom: '4px'}}
      >
        Generated URL
      </label>
      <LinkRow>
        <ShareLinkInput
          id="generated-link-url"
          readOnly
          value={link}
          onFocus={e => e.target.select()}
        />
        <Button variant="solid-dark-blue" size="sm" onClick={handleCopy}>
          {linkCopied ? 'Copied' : 'Copy'}
        </Button>
      </LinkRow>
    </Modal>
  )
}
